import {ComponentTypes} from "@white-label/components/page-builder/models/model.map";

export const SectionNavModel = [
    {
        label: 'Banner',
        type: ComponentTypes.banner,
        icon: '',
        allowedIn: ['all'],
        components: [
            {
                label: 'Hero Banner',
                type: ComponentTypes.hero,
                icon: ''
            },
            {
                label: 'Right To Left Banner',
                type: ComponentTypes.banner_right_left,
                icon: ''
            },
            {
                label: 'Left To Right Banner',
                type: ComponentTypes.banner_left_right,
                icon: ''
            },

            {
                label: 'Live stream',
                type: ComponentTypes.hero_live_stream,
                icon: ''
            },
            {
                label: 'Product Banner',
                type: ComponentTypes.hero_product,
                icon: ''
            },
            {
                label: 'Simple Banner',
                type: ComponentTypes.hero_simple_app,
                icon: ''
            },
            {
                label: 'Video Banner',
                type: ComponentTypes.hero_video,
                icon: ''
            },
            {
                label: 'Slider Banner',
                type: ComponentTypes.hero_slider,
                icon: ''
            }
        ]
    },
    {
        label: 'Sponsor',
        type: ComponentTypes.sponsor,
        icon: '',
        components: [

        ]
    },
    {
        label: 'F.A.Q.',
        type: ComponentTypes.faq,
        icon: '',
        components: [

        ]
    },
    {
        label: 'Latest Products',
        type: ComponentTypes.latestProducts,
        icon: '',
        components: [

        ]
    },
    {
        label: 'Carousel',
        type: ComponentTypes.carousel,
        icon: '',
        components: [

        ]
    },
    {
        label: 'Grid',
        type: ComponentTypes.grid,
        icon: '',
        components: [

        ]
    },
    {
        label: 'Text',
        type: ComponentTypes.text,
        icon: '',
        components: [

        ]
    },
    {
        label: 'Reviews',
        type: ComponentTypes.reviews,
        icon: '',
        components: [

        ]
    },
    {
        label: 'Contact us',
        type: ComponentTypes.contactUs,
        icon: '',
        components: [

        ]
    },
    {
        label: 'Ai Section',
        type: ComponentTypes.aiComponent,
        icon: '',
        components: [

        ]
    },
    {
        label: 'Pricing',
        type: ComponentTypes.pricing,
        icon: '',
        components: [

        ]
    },
    {
        label: 'Stats',
        type: ComponentTypes.stats,
        icon: '',
        components: [

        ]
    },
    {
        label: 'How it works',
        type: ComponentTypes.how_it_works,
        icon: '',
        components: [

        ]
    },
    {
        label: 'Pricing',
        type: ComponentTypes.pricing,
        icon: '',
        components: [

        ]
    },
    {
        label: 'donation_widgets',
        type: ComponentTypes.donationWidget,
        icon: '',
        components: [

        ]
    },
];